import { FAILED_SET_TOKENS, SET_TOKENS } from './actionsTypes'

const initialState = {
  tokens: {},
  number: '',
  errorMsg: null || {},
}

const LoginData = (state = initialState, { type, payload, number }) => {
  switch (type) {
    case SET_TOKENS:
      return {
        ...state,
        tokens: payload,
        number: number,
        errorMsg: null,
      }
    case FAILED_SET_TOKENS:
      return {
        ...state,
        errorMsg: payload,
      }

    default:
      return state
  }
}

export default LoginData
